import { IonButton, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonPage, IonRow, IonText, useIonRouter, useIonViewDidEnter, useIonViewWillEnter, useIonViewWillLeave } from '@ionic/react';
import { informationCircleOutline, logInOutline, personCircleOutline } from 'ionicons/icons';
import { useAppContext } from '../AppProvider';
import { Network } from '@capacitor/network';

const Home: React.FC = () => {

  const { authenticateMember, loading, setShowLoader, SWFullHorizLogo, textLogoLoaded, fadeInImage, fadeInTextLogo, present, dismiss } = useAppContext();
  
  const router = useIonRouter();

   useIonViewWillLeave(() => { 
        dismiss();
  }); 

  //
  // Authenticate Member
  //
  useIonViewWillEnter(() => { 
      document.body.classList.remove('dark');
      setShowLoader(true);
      const authenticate = async () => {
          const authenticated = await authenticateMember();   
          if(!authenticated || authenticated.mt == '') setTimeout(() => setShowLoader(false), 2000); 
          else {
              await present('Logging in...');
              const netstatus = await Network.getStatus();
              let connected = netstatus.connected;
              if (connected) router.push('/account/dashboard', 'forward');
              else setShowLoader(false);
          }
      };
      authenticate();
  });

  const rndContentClass = () => {
    let min = 1;
    let max = 1;
    min = Math.ceil(min); 
    max = Math.floor(max); 
    let num =  Math.floor(Math.random() * (max - min + 1)) + min;
    return 'home-content-bg-' + num + ' ion-padding';
  };
  
  return (
    <IonPage>
      <IonHeader>
      </IonHeader>
      <IonContent className={rndContentClass()} scrollY={false}>
        <IonGrid fixed>
            <IonRow class='ion-justify-content-center'>
                <IonCol size='12' sizeMd='8' sizeLg='6' sizeXl='4'>
                  <div>
                      <IonImg src={SWFullHorizLogo} alt='SoloWise' className='largeContentLogo' onIonImgDidLoad={fadeInImage} />
                  </div>
                  {/*<p className='ion-text-center'><IonText color={'primary'} style={{fontSize: '2rem'}}><strong>Plan for the unexpected</strong></IonText></p>*/}
                </IonCol>
            </IonRow>
            <IonRow class='ion-justify-content-center ion-margin-top'>
                <IonCol size='12' sizeSm='8' sizeMd='6' sizeLg='4' sizeXl='4'>
                  <IonCard style={{background: 'rgba(235, 245, 255, 0.75)', borderTop: 'none'}}>
                      <IonCardContent>
                        <IonButton className='ion-margin' type='button' expand='block' routerLink='/login'>
                            Log In <IonIcon icon={logInOutline} slot='end'></IonIcon>
                        </IonButton>
                        <IonButton className='ion-margin' color={'secondary'} type='button' expand='block' routerLink='/register'>
                            Sign Up <IonIcon icon={personCircleOutline} slot='end'></IonIcon>
                        </IonButton>
                        <IonButton className='ion-margin' color={'tertiary'} type='button' expand='block' routerLink='/about'>
                            Learn More <IonIcon icon={informationCircleOutline} slot='end'></IonIcon>
                        </IonButton>
                      </IonCardContent>
                  </IonCard>  
                </IonCol>
            </IonRow>
        </IonGrid>      
      </IonContent>
    </IonPage>
  );
};

export default Home;
